import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiConfigService {
  private apiUrl: string = 'http://localhost:3000/api';
  private wsUrl: string = 'http://localhost:3000';

  setApiUrl(url: string) {
    this.apiUrl = url;
  }

  setWsUrl(url: string) {
    this.wsUrl = url;
  }

  getApiUrl(): string {
    return this.apiUrl;
  }

  getWsUrl(): string {
    return this.wsUrl;
  }
}

